import { ITypedReduxAction } from '../../types/redux/actionType';
import { TChatListSetSucceedPayload } from '../chatList';

export enum EArchivedListActionTypes {
  SetPending = 'chats/archivedList/setPending',
  SetSucceed = 'chats/archivedList/setSucceed',
  SetFailed = 'chats/archivedList/setFailed',
}

export interface IArchivedListRequest {
  // timestamp последнего чата, последней страницы
  timestampArchive?: number;
}

export type TArchivedListActions =
  | ITypedReduxAction<EArchivedListActionTypes.SetPending, IArchivedListRequest>
  | ITypedReduxAction<EArchivedListActionTypes.SetSucceed, TChatListSetSucceedPayload>
  | ITypedReduxAction<EArchivedListActionTypes.SetFailed, void>;
